// Real Account API — /api/V1/Account/* (auth-required). Signatures mirror
// accountMock.ts so api/index.ts swaps mock ↔ real with one switch.

import { postJson } from './http';
import type { AccountInfo, AccountUpdateValues, SaveResult } from '@/types/api';

const API = '/api/V1';

export const accountRealApi = {
  async getAccount(): Promise<AccountInfo> {
    const res = await postJson<{ err: string; data?: AccountInfo }>(`${API}/Account/GetInfo`);
    if (res.err !== '1' || !res.data) throw new Error('Account lookup failed');
    return res.data;
  },

  async updateAccount(values: AccountUpdateValues): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Account/UpdateInfo`, { ...values });
  },
};
